import { EduSubjectPage } from './EduSubjectPage';
export default EduSubjectPage;
